exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.svg-icon[data-v-46ac5ae9] {\n    width: 1em;\n    height: 1em;\n    vertical-align: -0.15em;\n    fill: currentColor;\n    overflow: hidden;\n}\n.svg-external-icon[data-v-46ac5ae9] {\n    background-color: currentColor;\n    -webkit-mask-size: cover !important;\n            mask-size: cover !important;\n    display: inline-block;\n}\n", ""]);

// exports
